/*
 * Copyright (c) 2024.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

import {Component} from '@angular/core';
import {WPAIBase} from "./wpaibase";
import {ApiService} from "../services/api.service";
import {StudiebankComponent} from "./studiebank.component";
import {startupcomponent} from "../types";
import {RapportselectieComponent} from "./rapportselectie.component";


/**
 * Dit is de main dispatcher van de plugin. Het kan de admin-tools tonen, maar ook de boeking-tool (met de boeking-shortcode)
 * dispatch gebeurt op basis van wat de api ons teruggeeft, en die doet dat via de wpaib_apisettings setting
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    StudiebankComponent,
    RapportselectieComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: []
})
export class AppComponent extends WPAIBase {
  title = 'Studiebank door WP All-In';
  adminstate: 'studiebank' = 'studiebank';
  constructor(private api: ApiService) {
    super();
  }

  get startupcomponent(): startupcomponent {
    return this.api.startupcomponent;
  }
}
